/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowRightSmall: {
  name: 'arrow_right_small';
  data: string;
} = {
  name: 'arrow_right_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M13.344 7.532a.75.75 0 0 0-1.06 1.06l2.656 2.658H6.25a.75.75 0 0 0 0 1.5h8.69l-2.657 2.657a.75.75 0 0 0 1.061 1.06l3.937-3.937a.75.75 0 0 0 0-1.06l-3.937-3.938Z" fill="currentColor"/></svg>`
};
